/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable react-hooks/exhaustive-deps */
import React, {useState, useEffect} from "react";
import { useParams } from "react-router-dom";
import { Spinner, Container } from "reactstrap";
import Header from "../../components/Header";
import { getTransitPiecesByNameData, setPieceToCartData } from '../../api/request';
import NotificationAlert from "react-notification-alert";
import { primaryColor } from './../../utils/colors';

export default function PiecesTransit() {
  const notificationAlertRef = React.useRef(null);
  const {pi} = useParams();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(true);
  const [piece, setPiece] = useState({
    id: "",
    name: "",
    old: "",
    brand: "",
    brand_code: "",
    price: "",
    price2: "",
    quantity: "",
    description: "",
    picture: "",
    category: "",
    warehouse_code: "",
    warehouse_name: "",
    price_full: ""
  });
  const [quantity, setQuantity] = useState("1");
  const [cart_total, setCartTotal] = useState(0);

  useEffect(() => {
    getTransitPieceByName();
  },[]);

  const notifyAlert = (type, title, message) => {
    let options = {
      place: "tc",
      message: (
      <div className="alert-text">
          <span className="alert-title" data-notify="title">
            {" "}
            {title}
            <br />
          </span>
          <span data-notify="message">
            {message}
          </span>
        </div>
      ),
      type: type,
      icon: "ni ni-bell-55",
      autoDismiss: 5,
    };
    notificationAlertRef.current.notificationAlert(options);
  };

  const getTransitPieceByName = async () => {
    const res = await getTransitPiecesByNameData(pi);
    console.log(res.data);
    const data = res.data;

    if(res.status === 200) {
      setPiece({
        id: data.id,
        name: data.name,
        old: data.old,
        brand: data.brand,
        brand_code: data.brand_code,
        price: data.price,
        price2: data.price2,
        quantity: data.quantity,
        description: data.description,
        picture: data.picture,
        category: data.category,
        warehouse_code: data.warehouse_code,
        warehouse_name: data.warehouse_name,
        price_full: data.price_full,
      })
      setCartTotal(data.pieces);
      setLoading(false);
      setError(false);
    }
    else if(res.status === 404) {
      setLoading(false);
      setError(true);
    }
  }

  const getCategory = (c) => {
    switch(c) {
      case 1:
        return "Montura";
    
      case 2:
        return "Sol";

      default: 
        return "Error";
    }
  }

  const delPieces = () => {
    if(Number(quantity) <= 1) {
      setQuantity(1);
    }
    else {
      const total = Number(quantity) - 1;
      setQuantity(total);
    }
  }

  const addPieces = () => {
    if(Number(quantity) >= Number(piece.quantity)) {
      setQuantity(piece.quantity);
    }
    else {
      const total = Number(quantity) + 1;
      setQuantity(total);
    }
  }
  
  const addToCart = async () => {
    if(cart_total === 20) {
      notifyAlert("danger", "Mensaje", "No se pueden seleccionar mas de 20 piezas");
    }
    else {
      const total = parseFloat(piece.price) * parseFloat(quantity);
  
      const jsn = {
        "id": piece.id,
        "name": piece.name,
        "measurements": '',
        "description": piece.description,
        "old":piece.old,
        "available": piece.quantity,
        "brand": piece.brand_code,
        "brandName":piece.brand,
        "category":piece.category,
        "price": piece.price,
        "quantity": parseInt(quantity),
        "total": total.toFixed(2),
        "picture": piece.picture,
        "warehouse": piece.warehouse_code,
        "warehouse_name": piece.warehouse_name
      }
      const res = await setPieceToCartData(jsn);
  
      if(res.status === 200) {
        getTransitPieceByName();
        setCartTotal(res.data.piece);
        notifyAlert("success", "Mensaje", "Pieza agregada al carrito");
      }
      else if(res.status === 202) {
        setCartTotal(res.data.piece);
        notifyAlert("warning", "Mensaje", `No hay cantidad disponible para la pieza ${jsn.name}`);
      }
      else {
        notifyAlert("danger", "Mensaje", `Ha ocurrido un problema al agregar al carrito`);
      }
    }
  }

  return (
    <>
      <div className="rna-wrapper">
        <NotificationAlert ref={notificationAlertRef} />
      </div>

      <Header back />
      {
        (loading) ? 
          <div style={{
            textAlign: 'center'
          }}>
            <br />
            <Spinner style={{color: primaryColor}} />
          </div>
        : 
        <>
          {
            (error) ? <> 
              <div className="container text-center">
                <label style={{
                  fontSize: '127px',
                  fontWeight: 600,
                  color: '#444',
                }}> 404 </label>
                <br />
                <label style={{
                  fontSize: '64px',
                  fontWeight: 600,
                  color: '#444',
                }}> Esta pieza no existe. </label>
              </div>
            </>: 
            <>
              <div style={{
                display: 'block',
                textAlign: "center",
                borderBottom: '1px solid #d5d5d5',
                backgroundColor: '#fff'
              }}>
                <img className="piecePicture" alt="..." src={piece.picture} />
                <Container>
                  <a 
                    style={{
                      marginTop: "5px",
                      marginBottom: "5px",
                      backgroundColor: primaryColor,
                      border: "0",
                      color: "#fff",
                      padding: "10px 15px 10px 15px",
                      borderRadius: "5px",
                      display: "block",
                      textDecoration: "none",
                    }}
                    target="_blank" 
                    href={piece.picture}>Abrir imagen</a>
                </Container>
                <h2>En transito</h2>
              </div>
              
              <Container style={{
                marginBottom: '20px'
              }}>
                <ul id="pieceView">
                  <li>
                    <b>Nombre:</b>
                    <span>{piece.name}</span>
                  </li>
                  <li>
                    <b>Marca</b>
                    <span>{piece.brand}</span>
                  </li>
                  <li>
                    <b>Categoria</b>
                    <span>{getCategory(piece.category)}</span>
                  </li>
                  {
                    (!piece.price_full) ? "" : <>
                      <li>
                        <b>Precio</b>
                        <span>${Number(piece.price_full).toFixed(2)}</span>
                      </li>
                    </>
                  }
                  <li>
                    <b>Precio {(!piece.price_full) ? "" : "Oferta"}  </b>
                    <span>${Number(piece.price).toFixed(2)}</span>
                  </li>
                  <li>
                    <b>Disponibilidad</b>
                    <span>{piece.quantity}</span>
                  </li>
                  <li>
                    <b>Cantidad</b>
                    <ul style={{
                      display: "inline-flex",
                      padding: 0,
                      listStyle: 'none'
                    }}>
                      <li style={{ 
                        display: 'block'
                      }}>
                        <i style={{fontSize: '25px', marginTop: '6px', cursor: 'pointer'}} className="fas fa-minus-circle"  onClick={() => delPieces()}/>
                      </li>
                      <li style={{marginLeft: '10px', marginRight: '10px'}}>
                        <input
                          placeholder="1"
                          type="number"
                          min="0"
                          max={piece.quantity}
                          value={quantity}
                          style={{
                            width: '70px'
                          }}
                          className="form-control inputNumber" 
                          onChange={(val) => setQuantity(val.target.value)}/>
                      </li>
                      <li style={{
                        display: 'block',
                        lineHeight: 2.5
                      }}>
                        <i style={{fontSize: '25px', marginTop: '6px', cursor: 'pointer'}} className="fas fa-plus-circle" onClick={() => addPieces()}/>
                      </li>
                    </ul>
                  </li>
                </ul>
                <div>
                  <button 
                    className="btnFinishPiece"
                    style={{
                      backgroundColor: primaryColor,
                      border: "0"
                    }}
                    onClick={() => addToCart()}>Agregar al carrito</button>
                </div>
              </Container>
            </>
          }
        </>
      }
    </>
  )
}
